<div class="h-100-percent max-width-lg">
  <section class="flex flex-col justify-center items-center">
    <!-- <img class="mt-20 mb-20" src="/assets/images/Temenos Banking Cloud 2.png"><br> -->
    <img class="mt-24" src="/assets/images/404-not-found.png">
    <div class="mat-headline-5 fw-700 fs-28 mt-24"> {{ 'ERROR_PAGES.404_NOT_FOUND.DESCRIPTION' | transloco }} </div>
    <div class="mat-display-1 fw-500 error-code mt-8 mb-36"> {{ 'ERROR_PAGES.404_NOT_FOUND.404_ERROR' | transloco }} </div>
    <div class="flex flex-row justify-center items-center mb-20">
      <button (click)="goBack()" class="white mr-20"
              type="button"> {{ 'ERROR_PAGES.404_NOT_FOUND.BACK' | transloco }} </button>
    </div>
  </section>
</div>
